import { Dayjs } from "dayjs";

export function maxDate(date1: Dayjs, date2: Dayjs) {
  return date1.isAfter(date2) ? date1 : date2;
}
